import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { Props as MergeReleaseModalProps } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyMergeReleaseModal = lazy(() =>
	import(/* webpackChunkName: "async-merge-release-modal" */ './index').then(
		(module) => module.MergeReleaseModal,
	),
);

export const MergeReleaseModal = (props: MergeReleaseModalProps): React.JSX.Element => (
	<Placeholder name="merge-release-modal" fallback={null}>
		<LazyMergeReleaseModal {...props} />
	</Placeholder>
);
